import { Component, OnInit, PipeTransform, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { PlanosService } from '../planos.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { DecimalPipe } from '@angular/common';
import { LoaderService } from 'src/app/loader/loader.service';
import * as moment from 'moment';

@Component({
  selector: 'app-plano-details',
  templateUrl: './plano-details.component.html',
  styleUrls: ['./plano-details.component.scss'],
})
export class PlanoDetailsComponent implements OnInit {
  env;
  plano: Plano;
  itens$: Observable<ItemPlano[]>;
  timeoutIDError;

  page = 1;
  pageSize = 10;
  collectionSize = 0;
  filter = new FormControl('');

  @ViewChild('alertError', { read: ElementRef, static: false })
  alertError: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private planosService: PlanosService,
    private loaderService: LoaderService,
    private renderer: Renderer2
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.getPlano(this.env.selected.cnpj, this.route.snapshot.paramMap.get('id'));
  }

  async onSubmit() {
    const loader = await this.loaderService.notifica({
      title: 'Atualizando plano...',
      date: moment().toISOString(),
      type: 'loading',
    });

    const result = await this.planosService.updatePlano(this.plano.cnpj, this.plano._id, this.plano).toPromise();

    if ('error' in result) {
      this.addErrorAlert(result.error);
    } else {
      this.goPlanos();
    }

    loader.dismiss();
  }

  async getPlano(cnpj: string, id: string) {
    const loader = await this.loaderService.notifica({
      title: 'Buscando plano...',
      date: moment().toISOString(),
      type: 'loading',
    });

    this.plano = await this.planosService.getPlano(cnpj, id).toPromise();

    this.itens$ = this.filter.valueChanges.pipe(
      startWith(''),
      map(text => this.search(text, new DecimalPipe('pt')))
    );

    loader.dismiss();
  }

  async changeStatus(status: string) {
    const loader = await this.loaderService.notifica({
      title: 'Atualizando status...',
      date: moment().toISOString(),
      type: 'loading',
    });

    //-- Novo status
    const statusAnt = this.plano.status;
    this.plano.status = status;

    const result = await this.planosService.updatePlano(this.plano.cnpj, this.plano._id, this.plano).toPromise();

    if ('error' in result) {
      this.plano.status = statusAnt;
      this.addErrorAlert(result.error);
    } else {
      this.goPlanos();
    }

    loader.dismiss();
  }

  addErrorAlert(msg: string) {
    clearTimeout(this.timeoutIDError);

    this.renderer.setProperty(this.alertError.nativeElement, 'innerHTML', msg);
    this.renderer.setProperty(this.alertError.nativeElement, 'hidden', false);

    this.timeoutIDError = setTimeout(_ => {
      this.renderer.setProperty(this.alertError.nativeElement, 'hidden', true);
    }, 8000);
  }

  search(text: string, pipe: PipeTransform): ItemPlano[] {
    const itensFiltered: ItemPlano[] = this.plano.itens.filter(item => {
      const term = text.toLowerCase();
      return (
        item.codigo.toLowerCase().includes(term) ||
        item.descricao.toLowerCase().includes(term) ||
        pipe.transform(item.quantidade).includes(term)
      );
    });

    this.page = 1;
    this.collectionSize = itensFiltered.length;

    return itensFiltered;
  }

  goPlanos(): void {
    this.router.navigateByUrl(`/planos/${this.env.selected.cnpj}`);
  }

  goBack(): void {
    this.router.navigateByUrl(`/settings/${this.env.selected.cnpj}`);
  }
}
